import { getFixedT } from '@app/core/i18n';

import { Country, CountryCodes, ISO3CountryCodes } from './types';

const t = getFixedT(null, null);

export const countries: Country[] = [
  {
    name: t('countries.af.label|AF country name label', 'Afghanistan (‫افغانستان‬‎)'),
    countryCode: CountryCodes.AF,
    dialCode: '+93',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.AFG
  },
  {
    name: t('countries.al.label|AL country name label', 'Albania (Shqipëri)'),
    countryCode: CountryCodes.AL,
    dialCode: '+355',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ALB
  },
  {
    name: t('countries.dz.label|DZ country name label', 'Algeria (‫الجزائر‬‎)'),
    countryCode: CountryCodes.DZ,
    dialCode: '+213',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.DZA
  },
  {
    name: t('countries.as.label|AS country name label', 'American Samoa'),
    countryCode: CountryCodes.AS,
    dialCode: '+1',
    priority: 5,
    areaCodes: ["684"],
    ISO3CountryCodes: ISO3CountryCodes.ASM
  },
  {
    name: t('countries.ad.label|AD country name label', 'Andorra'),
    countryCode: CountryCodes.AD,
    dialCode: '+376',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.AND
  },
  {
    name: t('countries.ao.label|AO country name label', 'Angola'),
    countryCode: CountryCodes.AO,
    dialCode: '+244',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.AGO
  },
  {
    name: t('countries.ai.label|AI country name label', 'Anguilla'),
    countryCode: CountryCodes.AI,
    dialCode: '+1',
    priority: 6,
    areaCodes: ["264"],
    ISO3CountryCodes: ISO3CountryCodes.AIA
  },
  {
    name: t('countries.ag.label|AG country name label', 'Antigua and Barbuda'),
    countryCode: CountryCodes.AG,
    dialCode: '+1',
    priority: 7,
    areaCodes: ["268"],
    ISO3CountryCodes: ISO3CountryCodes.ATG
  },
  {
    name: t('countries.ar.label|AR country name label', 'Argentina'),
    countryCode: CountryCodes.AR,
    dialCode: '+54',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ARG
  },
  {
    name: t('countries.am.label|AM country name label', 'Armenia (Հայաստան)'),
    countryCode: CountryCodes.AM,
    dialCode: '+374',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ARM
  },
  {
    name: t('countries.aw.label|AW country name label', 'Aruba'),
    countryCode: CountryCodes.AW,
    dialCode: '+297',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ABW
  },
  {
    name: t('countries.ac.label|AC country name label', 'Ascension Island'),
    countryCode: CountryCodes.AC,
    dialCode: '+247',
    priority: 0,
  },
  {
    name: t('countries.au.label|AU country name label', 'Australia'),
    countryCode: CountryCodes.AU,
    dialCode: '+61',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.AUS
  },
  {
    name: t('countries.at.label|AT country name label', 'Austria (Österreich)'),
    countryCode: CountryCodes.AT,
    dialCode: '+43',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.AUT
  },
  {
    name: t('countries.az.label|AZ country name label', 'Azerbaijan (Azərbaycan)'),
    countryCode: CountryCodes.AZ,
    dialCode: '+994',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.AZE
  },
  {
    name: t('countries.bs.label|BS country name label', 'Bahamas'),
    countryCode: CountryCodes.BS,
    dialCode: '+1',
    priority: 8,
    areaCodes: ["242"],
    ISO3CountryCodes: ISO3CountryCodes.BHS
  },
  {
    name: t('countries.bh.label|BH country name label', 'Bahrain (‫البحرين‬‎)'),
    countryCode: CountryCodes.BH,
    dialCode: '+973',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BHR
  },
  {
    name: t('countries.bd.label|BD country name label', 'Bangladesh (বাংলাদেশ)'),
    countryCode: CountryCodes.BD,
    dialCode: '+880',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BGD
  },
  {
    name: t('countries.bb.label|BB country name label', 'Barbados'),
    countryCode: CountryCodes.BB,
    dialCode: '+1',
    priority: 9,
    areaCodes: ["246"],
    ISO3CountryCodes: ISO3CountryCodes.BRB
  },
  {
    name: t('countries.by.label|BY country name label', 'Belarus (Беларусь)'),
    countryCode: CountryCodes.BY,
    dialCode: '+375',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BLR
  },
  {
    name: t('countries.be.label|BE country name label', 'Belgium (België)'),
    countryCode: CountryCodes.BE,
    dialCode: '+32',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BEL
  },
  {
    name: t('countries.bz.label|BZ country name label', 'Belize'),
    countryCode: CountryCodes.BZ,
    dialCode: '+501',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BLZ
  },
  {
    name: t('countries.bj.label|BJ country name label', 'Benin (Bénin)'),
    countryCode: CountryCodes.BJ,
    dialCode: '+229',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BEN
  },
  {
    name: t('countries.bm.label|BM country name label', 'Bermuda'),
    countryCode: CountryCodes.BM,
    dialCode: '+1',
    priority: 10,
    areaCodes: ["441"],
    ISO3CountryCodes: ISO3CountryCodes.BMU
  },
  {
    name: t('countries.bt.label|BT country name label', 'Bhutan (འབྲུག)'),
    countryCode: CountryCodes.BT,
    dialCode: '+975',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BTN
  },
  {
    name: t('countries.bo.label|BO country name label', 'Bolivia'),
    countryCode: CountryCodes.BO,
    dialCode: '+591',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BOL
  },
  {
    name: t('countries.ba.label|BA country name label', 'Bosnia and Herzegovina (Босна и Херцеговина)'),
    countryCode: CountryCodes.BA,
    dialCode: '+387',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BIH
  },
  {
    name: t('countries.bw.label|BW country name label', 'Botswana'),
    countryCode: CountryCodes.BW,
    dialCode: '+267',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BWA
  },
  {
    name: t('countries.br.label|BR country name label', 'Brazil (Brasil)'),
    countryCode: CountryCodes.BR,
    dialCode: '+55',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BRA
  },
  {
    name: t('countries.io.label|IO country name label', 'British Indian Ocean Territory'),
    countryCode: CountryCodes.IO,
    dialCode: '+246',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.IOT
  },
  {
    name: t('countries.vg.label|VG country name label', 'British Virgin Islands'),
    countryCode: CountryCodes.VG,
    dialCode: '+1',
    priority: 11,
    areaCodes: ["284"],
    ISO3CountryCodes: ISO3CountryCodes.VGB
  },
  {
    name: t('countries.bn.label|BN country name label', 'Brunei'),
    countryCode: CountryCodes.BN,
    dialCode: '+673',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BRN
  },
  {
    name: t('countries.bg.label|BG country name label', 'Bulgaria (България)'),
    countryCode: CountryCodes.BG,
    dialCode: '+359',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BGR
  },
  {
    name: t('countries.bf.label|BF country name label', 'Burkina Faso'),
    countryCode: CountryCodes.BF,
    dialCode: '+226',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BFA
  },
  {
    name: t('countries.bi.label|BI country name label', 'Burundi (Uburundi)'),
    countryCode: CountryCodes.BI,
    dialCode: '+257',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.BDI
  },
  {
    name: t('countries.kh.label|KH country name label', 'Cambodia (កម្ពុជា)'),
    countryCode: CountryCodes.KH,
    dialCode: '+855',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.KHM
  },
  {
    name: t('countries.cm.label|CM country name label', 'Cameroon (Cameroun)'),
    countryCode: CountryCodes.CM,
    dialCode: '+237',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CMR
  },
  {
    name: t('countries.ca.label|CA country name label', 'Canada'),
    countryCode: CountryCodes.CA,
    dialCode: '+1',
    priority: 1,
    areaCodes: ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"],
    ISO3CountryCodes: ISO3CountryCodes.CAN
  },
  {
    name: t('countries.cv.label|CV country name label', 'Cape Verde (Kabu Verdi)'),
    countryCode: CountryCodes.CV,
    dialCode: '+238',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CPV
  },
  {
    name: t('countries.bq.label|BQ country name label', 'Caribbean Netherlands'),
    countryCode: CountryCodes.BQ,
    dialCode: '+599',
    priority: 1,
    areaCodes: ["3", "4", "7"],
    ISO3CountryCodes: ISO3CountryCodes.BES
  },
  {
    name: t('countries.ky.label|KY country name label', 'Cayman Islands'),
    countryCode: CountryCodes.KY,
    dialCode: '+1',
    priority: 12,
    areaCodes: ["345"],
    ISO3CountryCodes: ISO3CountryCodes.CYM
  },
  {
    name: t('countries.cf.label|CF country name label', 'Central African Republic (République centrafricaine)'),
    countryCode: CountryCodes.CF,
    dialCode: '+236',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CAF
  },
  {
    name: t('countries.td.label|TD country name label', 'Chad (Tchad)'),
    countryCode: CountryCodes.TD,
    dialCode: '+235',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TCD
  },
  {
    name: t('countries.cl.label|CL country name label', 'Chile'),
    countryCode: CountryCodes.CL,
    dialCode: '+56',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CHL
  },
  {
    name: t('countries.cn.label|CN country name label', 'China (中国)'),
    countryCode: CountryCodes.CN,
    dialCode: '+86',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CHN
  },
  {
    name: t('countries.cx.label|CX country name label', 'Christmas Island'),
    countryCode: CountryCodes.CX,
    dialCode: '+61',
    priority: 2,
    areaCodes: ["89164"],
    ISO3CountryCodes: ISO3CountryCodes.CXR
  },
  {
    name: t('countries.cc.label|CC country name label', 'Cocos (Keeling) Islands'),
    countryCode: CountryCodes.CC,
    dialCode: '+61',
    priority: 1,
    areaCodes: ["89162"],
    ISO3CountryCodes: ISO3CountryCodes.CCK
  },
  {
    name: t('countries.co.label|CO country name label', 'Colombia'),
    countryCode: CountryCodes.CO,
    dialCode: '+57',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.COL
  },
  {
    name: t('countries.km.label|KM country name label', 'Comoros (‫جزر القمر‬‎)'),
    countryCode: CountryCodes.KM,
    dialCode: '+269',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.COM
  },
  {
    name: t('countries.cd.label|CD country name label', 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)'),
    countryCode: CountryCodes.CD,
    dialCode: '+243',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.COD
  },
  {
    name: t('countries.cg.label|CG country name label', 'Congo (Republic) (Congo-Brazzaville)'),
    countryCode: CountryCodes.CG,
    dialCode: '+242',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.COG
  },
  {
    name: t('countries.ck.label|CK country name label', 'Cook Islands'),
    countryCode: CountryCodes.CK,
    dialCode: '+682',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.COK
  },
  {
    name: t('countries.cr.label|CR country name label', 'Costa Rica'),
    countryCode: CountryCodes.CR,
    dialCode: '+506',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CRI
  },
  {
    name: t('countries.ci.label|CI country name label', 'Côte d’Ivoire'),
    countryCode: CountryCodes.CI,
    dialCode: '+225',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CIV
  },
  {
    name: t('countries.hr.label|HR country name label', 'Croatia (Hrvatska)'),
    countryCode: CountryCodes.HR,
    dialCode: '+385',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.HRV
  },
  {
    name: t('countries.cu.label|CU country name label', 'Cuba'),
    countryCode: CountryCodes.CU,
    dialCode: '+53',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CUB
  },
  {
    name: t('countries.cw.label|CW country name label', 'Curaçao'),
    countryCode: CountryCodes.CW,
    dialCode: '+599',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CUW
  },
  {
    name: t('countries.cy.label|CY country name label', 'Cyprus (Κύπρος)'),
    countryCode: CountryCodes.CY,
    dialCode: '+357',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CYP
  },
  {
    name: t('countries.cz.label|CZ country name label', 'Czech Republic (Česká republika)'),
    countryCode: CountryCodes.CZ,
    dialCode: '+420',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CZE
  },
  {
    name: t('countries.dk.label|DK country name label', 'Denmark (Danmark)'),
    countryCode: CountryCodes.DK,
    dialCode: '+45',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.DNK
  },
  {
    name: t('countries.dj.label|DJ country name label', 'Djibouti'),
    countryCode: CountryCodes.DJ,
    dialCode: '+253',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.DJI
  },
  {
    name: t('countries.dm.label|DM country name label', 'Dominica'),
    countryCode: CountryCodes.DM,
    dialCode: '+1',
    priority: 13,
    areaCodes: ["767"],
    ISO3CountryCodes: ISO3CountryCodes.DMA
  },
  {
    name: t('countries.do.label|DO country name label', 'Dominican Republic (República Dominicana)'),
    countryCode: CountryCodes.DO,
    dialCode: '+1',
    priority: 2,
    areaCodes: ["809", "829", "849"],
    ISO3CountryCodes: ISO3CountryCodes.DOM
  },
  {
    name: t('countries.ec.label|EC country name label', 'Ecuador'),
    countryCode: CountryCodes.EC,
    dialCode: '+593',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ECU
  },
  {
    name: t('countries.eg.label|EG country name label', 'Egypt (‫مصر‬‎)'),
    countryCode: CountryCodes.EG,
    dialCode: '+20',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.EGY
  },
  {
    name: t('countries.sv.label|SV country name label', 'El Salvador'),
    countryCode: CountryCodes.SV,
    dialCode: '+503',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SLV
  },
  {
    name: t('countries.gq.label|GQ country name label', 'Equatorial Guinea (Guinea Ecuatorial)'),
    countryCode: CountryCodes.GQ,
    dialCode: '+240',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GNQ
  },
  {
    name: t('countries.er.label|ER country name label', 'Eritrea'),
    countryCode: CountryCodes.ER,
    dialCode: '+291',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ERI
  },
  {
    name: t('countries.ee.label|EE country name label', 'Estonia (Eesti)'),
    countryCode: CountryCodes.EE,
    dialCode: '+372',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.EST
  },
  {
    name: t('countries.sz.label|SZ country name label', 'Eswatini'),
    countryCode: CountryCodes.SZ,
    dialCode: '+268',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SWZ
  },
  {
    name: t('countries.et.label|ET country name label', 'Ethiopia'),
    countryCode: CountryCodes.ET,
    dialCode: '+251',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ETH
  },
  {
    name: t('countries.fk.label|FK country name label', 'Falkland Islands (Islas Malvinas)'),
    countryCode: CountryCodes.FK,
    dialCode: '+500',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.FLK
  },
  {
    name: t('countries.fo.label|FO country name label', 'Faroe Islands (Føroyar)'),
    countryCode: CountryCodes.FO,
    dialCode: '+298',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.FRO
  },
  {
    name: t('countries.fj.label|FJ country name label', 'Fiji'),
    countryCode: CountryCodes.FJ,
    dialCode: '+679',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.FJI
  },
  {
    name: t('countries.fi.label|FI country name label', 'Finland (Suomi)'),
    countryCode: CountryCodes.FI,
    dialCode: '+358',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.FIN
  },
  {
    name: t('countries.fr.label|FR country name label', 'France'),
    countryCode: CountryCodes.FR,
    dialCode: '+33',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.FRA
  },
  {
    name: t('countries.gf.label|GF country name label', 'French Guiana (Guyane française)'),
    countryCode: CountryCodes.GF,
    dialCode: '+594',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GUF
  },
  {
    name: t('countries.pf.label|PF country name label', 'French Polynesia (Polynésie française)'),
    countryCode: CountryCodes.PF,
    dialCode: '+689',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PYF
  },
  {
    name: t('countries.ga.label|GA country name label', 'Gabon'),
    countryCode: CountryCodes.GA,
    dialCode: '+241',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GAB
  },
  {
    name: t('countries.gm.label|GM country name label', 'Gambia'),
    countryCode: CountryCodes.GM,
    dialCode: '+220',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GMB
  },
  {
    name: t('countries.ge.label|GE country name label', 'Georgia (საქართველო)'),
    countryCode: CountryCodes.GE,
    dialCode: '+995',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GEO
  },
  {
    name: t('countries.de.label|DE country name label', 'Germany (Deutschland)'),
    countryCode: CountryCodes.DE,
    dialCode: '+49',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.DEU
  },
  {
    name: t('countries.gh.label|GH country name label', 'Ghana (Gaana)'),
    countryCode: CountryCodes.GH,
    dialCode: '+233',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GHA
  },
  {
    name: t('countries.gi.label|GI country name label', 'Gibraltar'),
    countryCode: CountryCodes.GI,
    dialCode: '+350',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GIB
  },
  {
    name: t('countries.gr.label|GR country name label', 'Greece (Ελλάδα)'),
    countryCode: CountryCodes.GR,
    dialCode: '+30',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GRC
  },
  {
    name: t('countries.gl.label|GL country name label', 'Greenland (Kalaallit Nunaat)'),
    countryCode: CountryCodes.GL,
    dialCode: '+299',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GRL
  },
  {
    name: t('countries.gd.label|GD country name label', 'Grenada'),
    countryCode: CountryCodes.GD,
    dialCode: '+1',
    priority: 14,
    areaCodes: ["473"],
    ISO3CountryCodes: ISO3CountryCodes.GRD
  },
  {
    name: t('countries.gp.label|GP country name label', 'Guadeloupe'),
    countryCode: CountryCodes.GP,
    dialCode: '+590',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GLP
  },
  {
    name: t('countries.gu.label|GU country name label', 'Guam'),
    countryCode: CountryCodes.GU,
    dialCode: '+1',
    priority: 15,
    areaCodes: ["671"],
    ISO3CountryCodes: ISO3CountryCodes.GUM
  },
  {
    name: t('countries.gt.label|GT country name label', 'Guatemala'),
    countryCode: CountryCodes.GT,
    dialCode: '+502',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GTM
  },
  {
    name: t('countries.gg.label|GG country name label', 'Guernsey'),
    countryCode: CountryCodes.GG,
    dialCode: '+44',
    priority: 1,
    areaCodes: ["1481", "7781", "7839", "7911"],
    ISO3CountryCodes: ISO3CountryCodes.GGY
  },
  {
    name: t('countries.gn.label|GN country name label', 'Guinea (Guinée)'),
    countryCode: CountryCodes.GN,
    dialCode: '+224',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GIN
  },
  {
    name: t('countries.gw.label|GW country name label', 'Guinea-Bissau (Guiné Bissau)'),
    countryCode: CountryCodes.GW,
    dialCode: '+245',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GNB
  },
  {
    name: t('countries.gy.label|GY country name label', 'Guyana'),
    countryCode: CountryCodes.GY,
    dialCode: '+592',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GUY
  },
  {
    name: t('countries.ht.label|HT country name label', 'Haiti'),
    countryCode: CountryCodes.HT,
    dialCode: '+509',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.HTI
  },
  {
    name: t('countries.hn.label|HN country name label', 'Honduras'),
    countryCode: CountryCodes.HN,
    dialCode: '+504',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.HND
  },
  {
    name: t('countries.hk.label|HK country name label', 'Hong Kong (香港)'),
    countryCode: CountryCodes.HK,
    dialCode: '+852',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.HKG
  },
  {
    name: t('countries.hu.label|HU country name label', 'Hungary (Magyarország)'),
    countryCode: CountryCodes.HU,
    dialCode: '+36',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.HUN
  },
  {
    name: t('countries.is.label|IS country name label', 'Iceland (Ísland)'),
    countryCode: CountryCodes.IS,
    dialCode: '+354',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ISL
  },
  {
    name: t('countries.in.label|IN country name label', 'India (भारत)'),
    countryCode: CountryCodes.IN,
    dialCode: '+91',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.IND
  },
  {
    name: t('countries.id.label|ID country name label', 'Indonesia'),
    countryCode: CountryCodes.ID,
    dialCode: '+62',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.IDN
  },
  {
    name: t('countries.ir.label|IR country name label', 'Iran (‫ایران‬‎)'),
    countryCode: CountryCodes.IR,
    dialCode: '+98',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.IRN
  },
  {
    name: t('countries.iq.label|IQ country name label', 'Iraq (‫العراق‬‎)'),
    countryCode: CountryCodes.IQ,
    dialCode: '+964',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.IRQ
  },
  {
    name: t('countries.ie.label|IE country name label', 'Ireland'),
    countryCode: CountryCodes.IE,
    dialCode: '+353',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.IRL
  },
  {
    name: t('countries.im.label|IM country name label', 'Isle of Man'),
    countryCode: CountryCodes.IM,
    dialCode: '+44',
    priority: 2,
    areaCodes: ["1624", "74576", "7524", "7924", "7624"],
    ISO3CountryCodes: ISO3CountryCodes.IMN
  },
  {
    name: t('countries.il.label|IL country name label', 'Israel (‫ישראל‬‎)'),
    countryCode: CountryCodes.IL,
    dialCode: '+972',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ISR
  },
  {
    name: t('countries.it.label|IT country name label', 'Italy (Italia)'),
    countryCode: CountryCodes.IT,
    dialCode: '+39',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ITA
  },
  {
    name: t('countries.jm.label|JM country name label', 'Jamaica'),
    countryCode: CountryCodes.JM,
    dialCode: '+1',
    priority: 4,
    areaCodes: ["876", "658"],
    ISO3CountryCodes: ISO3CountryCodes.JAM
  },
  {
    name: t('countries.jp.label|JP country name label', 'Japan (日本)'),
    countryCode: CountryCodes.JP,
    dialCode: '+81',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.JPN
  },
  {
    name: t('countries.je.label|JE country name label', 'Jersey'),
    countryCode: CountryCodes.JE,
    dialCode: '+44',
    priority: 3,
    areaCodes: ["1534", "7509", "7700", "7797", "7829", "7937"],
    ISO3CountryCodes: ISO3CountryCodes.JEY
  },
  {
    name: t('countries.jo.label|JO country name label', 'Jordan (‫الأردن‬‎)'),
    countryCode: CountryCodes.JO,
    dialCode: '+962',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.JOR
  },
  {
    name: t('countries.kz.label|KZ country name label', 'Kazakhstan (Казахстан)'),
    countryCode: CountryCodes.KZ,
    dialCode: '+7',
    priority: 1,
    areaCodes: ["33", "7"],
    ISO3CountryCodes: ISO3CountryCodes.KAZ
  },
  {
    name: t('countries.ke.label|KE country name label', 'Kenya'),
    countryCode: CountryCodes.KE,
    dialCode: '+254',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.KEN
  },
  {
    name: t('countries.ki.label|KI country name label', 'Kiribati'),
    countryCode: CountryCodes.KI,
    dialCode: '+686',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.KIR
  },
  {
    name: t('countries.xk.label|XK country name label', 'Kosovo'),
    countryCode: CountryCodes.XK,
    dialCode: '+383',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.XKX
  },
  {
    name: t('countries.kw.label|KW country name label', 'Kuwait (‫الكويت‬‎)'),
    countryCode: CountryCodes.KW,
    dialCode: '+965',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.KWT
  },
  {
    name: t('countries.kg.label|KG country name label', 'Kyrgyzstan (Кыргызстан)'),
    countryCode: CountryCodes.KG,
    dialCode: '+996',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.KGZ
  },
  {
    name: t('countries.la.label|LA country name label', 'Laos (ລາວ)'),
    countryCode: CountryCodes.LA,
    dialCode: '+856',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LAO
  },
  {
    name: t('countries.lv.label|LV country name label', 'Latvia (Latvija)'),
    countryCode: CountryCodes.LV,
    dialCode: '+371',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LVA
  },
  {
    name: t('countries.lb.label|LB country name label', 'Lebanon (‫لبنان‬‎)'),
    countryCode: CountryCodes.LB,
    dialCode: '+961',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LBN
  },
  {
    name: t('countries.ls.label|LS country name label', 'Lesotho'),
    countryCode: CountryCodes.LS,
    dialCode: '+266',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LSO
  },
  {
    name: t('countries.lr.label|LR country name label', 'Liberia'),
    countryCode: CountryCodes.LR,
    dialCode: '+231',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LBR
  },
  {
    name: t('countries.ly.label|LY country name label', 'Libya (‫ليبيا‬‎)'),
    countryCode: CountryCodes.LY,
    dialCode: '+218',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LBY
  },
  {
    name: t('countries.li.label|LI country name label', 'Liechtenstein'),
    countryCode: CountryCodes.LI,
    dialCode: '+423',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LIE
  },
  {
    name: t('countries.lt.label|LT country name label', 'Lithuania (Lietuva)'),
    countryCode: CountryCodes.LT,
    dialCode: '+370',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LTU
  },
  {
    name: t('countries.lu.label|LU country name label', 'Luxembourg'),
    countryCode: CountryCodes.LU,
    dialCode: '+352',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LUX
  },
  {
    name: t('countries.mo.label|MO country name label', 'Macau (澳門)'),
    countryCode: CountryCodes.MO,
    dialCode: '+853',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MAC
  },
  {
    name: t('countries.mg.label|MG country name label', 'Madagascar (Madagasikara)'),
    countryCode: CountryCodes.MG,
    dialCode: '+261',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MDG
  },
  {
    name: t('countries.mw.label|MW country name label', 'Malawi'),
    countryCode: CountryCodes.MW,
    dialCode: '+265',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MWI
  },
  {
    name: t('countries.my.label|MY country name label', 'Malaysia'),
    countryCode: CountryCodes.MY,
    dialCode: '+60',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MYS
  },
  {
    name: t('countries.mv.label|MV country name label', 'Maldives'),
    countryCode: CountryCodes.MV,
    dialCode: '+960',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MDV
  },
  {
    name: t('countries.ml.label|ML country name label', 'Mali'),
    countryCode: CountryCodes.ML,
    dialCode: '+223',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MLI
  },
  {
    name: t('countries.mt.label|MT country name label', 'Malta'),
    countryCode: CountryCodes.MT,
    dialCode: '+356',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MLT
  },
  {
    name: t('countries.mh.label|MH country name label', 'Marshall Islands'),
    countryCode: CountryCodes.MH,
    dialCode: '+692',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MHL
  },
  {
    name: t('countries.mq.label|MQ country name label', 'Martinique'),
    countryCode: CountryCodes.MQ,
    dialCode: '+596',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MTQ
  },
  {
    name: t('countries.mr.label|MR country name label', 'Mauritania (‫موريتانيا‬‎)'),
    countryCode: CountryCodes.MR,
    dialCode: '+222',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MRT
  },
  {
    name: t('countries.mu.label|MU country name label', 'Mauritius (Moris)'),
    countryCode: CountryCodes.MU,
    dialCode: '+230',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MUS
  },
  {
    name: t('countries.yt.label|YT country name label', 'Mayotte'),
    countryCode: CountryCodes.YT,
    dialCode: '+262',
    priority: 1,
    areaCodes: ["269", "639"],
    ISO3CountryCodes: ISO3CountryCodes.MYT
  },
  {
    name: t('countries.mx.label|MX country name label', 'Mexico (México)'),
    countryCode: CountryCodes.MX,
    dialCode: '+52',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MEX
  },
  {
    name: t('countries.fm.label|FM country name label', 'Micronesia'),
    countryCode: CountryCodes.FM,
    dialCode: '+691',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.FSM
  },
  {
    name: t('countries.md.label|MD country name label', 'Moldova (Republica Moldova)'),
    countryCode: CountryCodes.MD,
    dialCode: '+373',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MDA
  },
  {
    name: t('countries.mc.label|MC country name label', 'Monaco'),
    countryCode: CountryCodes.MC,
    dialCode: '+377',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MCO
  },
  {
    name: t('countries.mn.label|MN country name label', 'Mongolia (Монгол)'),
    countryCode: CountryCodes.MN,
    dialCode: '+976',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MNG
  },
  {
    name: t('countries.me.label|ME country name label', 'Montenegro (Crna Gora)'),
    countryCode: CountryCodes.ME,
    dialCode: '+382',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MNE
  },
  {
    name: t('countries.ms.label|MS country name label', 'Montserrat'),
    countryCode: CountryCodes.MS,
    dialCode: '+1',
    priority: 16,
    areaCodes: ["664"],
    ISO3CountryCodes: ISO3CountryCodes.MSR
  },
  {
    name: t('countries.ma.label|MA country name label', 'Morocco (‫المغرب‬‎)'),
    countryCode: CountryCodes.MA,
    dialCode: '+212',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MAR
  },
  {
    name: t('countries.mz.label|MZ country name label', 'Mozambique (Moçambique)'),
    countryCode: CountryCodes.MZ,
    dialCode: '+258',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MOZ
  },
  {
    name: t('countries.mm.label|MM country name label', 'Myanmar (Burma) (မြန်မာ)'),
    countryCode: CountryCodes.MM,
    dialCode: '+95',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MMR
  },
  {
    name: t('countries.na.label|NA country name label', 'Namibia (Namibië)'),
    countryCode: CountryCodes.NA,
    dialCode: '+264',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NAM
  },
  {
    name: t('countries.nr.label|NR country name label', 'Nauru'),
    countryCode: CountryCodes.NR,
    dialCode: '+674',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NRU
  },
  {
    name: t('countries.np.label|NP country name label', 'Nepal (नेपाल)'),
    countryCode: CountryCodes.NP,
    dialCode: '+977',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NPL
  },
  {
    name: t('countries.nl.label|NL country name label', 'Netherlands (Nederland)'),
    countryCode: CountryCodes.NL,
    dialCode: '+31',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NLD
  },
  {
    name: t('countries.nc.label|NC country name label', 'New Caledonia (Nouvelle-Calédonie)'),
    countryCode: CountryCodes.NC,
    dialCode: '+687',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NCL
  },
  {
    name: t('countries.nz.label|NZ country name label', 'New Zealand'),
    countryCode: CountryCodes.NZ,
    dialCode: '+64',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NZL
  },
  {
    name: t('countries.ni.label|NI country name label', 'Nicaragua'),
    countryCode: CountryCodes.NI,
    dialCode: '+505',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NIC
  },
  {
    name: t('countries.ne.label|NE country name label', 'Niger (Nijar)'),
    countryCode: CountryCodes.NE,
    dialCode: '+227',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NER
  },
  {
    name: t('countries.ng.label|NG country name label', 'Nigeria'),
    countryCode: CountryCodes.NG,
    dialCode: '+234',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NGA
  },
  {
    name: t('countries.nu.label|NU country name label', 'Niue'),
    countryCode: CountryCodes.NU,
    dialCode: '+683',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NIU
  },
  {
    name: t('countries.nf.label|NF country name label', 'Norfolk Island'),
    countryCode: CountryCodes.NF,
    dialCode: '+672',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NFK
  },
  {
    name: t('countries.kp.label|KP country name label', 'North Korea (조선 민주주의 인민 공화국)'),
    countryCode: CountryCodes.KP,
    dialCode: '+850',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PRK
  },
  {
    name: t('countries.mk.label|MK country name label', 'North Macedonia (Северна Македонија)'),
    countryCode: CountryCodes.MK,
    dialCode: '+389',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.MKD
  },
  {
    name: t('countries.mp.label|MP country name label', 'Northern Mariana Islands'),
    countryCode: CountryCodes.MP,
    dialCode: '+1',
    priority: 17,
    areaCodes: ["670"],
    ISO3CountryCodes: ISO3CountryCodes.MNP
  },
  {
    name: t('countries.no.label|NO country name label', 'Norway (Norge)'),
    countryCode: CountryCodes.NO,
    dialCode: '+47',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.NOR
  },
  {
    name: t('countries.om.label|OM country name label', 'Oman (‫عُمان‬‎)'),
    countryCode: CountryCodes.OM,
    dialCode: '+968',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.OMN
  },
  {
    name: t('countries.pk.label|PK country name label', 'Pakistan (‫پاکستان‬‎)'),
    countryCode: CountryCodes.PK,
    dialCode: '+92',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PAK
  },
  {
    name: t('countries.pw.label|PW country name label', 'Palau'),
    countryCode: CountryCodes.PW,
    dialCode: '+680',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PLW
  },
  {
    name: t('countries.ps.label|PS country name label', 'Palestine (‫فلسطين‬‎)'),
    countryCode: CountryCodes.PS,
    dialCode: '+970',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PSE
  },
  {
    name: t('countries.pa.label|PA country name label', 'Panama (Panamá)'),
    countryCode: CountryCodes.PA,
    dialCode: '+507',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PAN
  },
  {
    name: t('countries.pg.label|PG country name label', 'Papua New Guinea'),
    countryCode: CountryCodes.PG,
    dialCode: '+675',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PNG
  },
  {
    name: t('countries.py.label|PY country name label', 'Paraguay'),
    countryCode: CountryCodes.PY,
    dialCode: '+595',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PRY
  },
  {
    name: t('countries.pe.label|PE country name label', 'Peru (Perú)'),
    countryCode: CountryCodes.PE,
    dialCode: '+51',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PER
  },
  {
    name: t('countries.ph.label|PH country name label', 'Philippines'),
    countryCode: CountryCodes.PH,
    dialCode: '+63',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PHL
  },
  {
    name: t('countries.pl.label|PL country name label', 'Poland (Polska)'),
    countryCode: CountryCodes.PL,
    dialCode: '+48',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.POL
  },
  {
    name: t('countries.pt.label|PT country name label', 'Portugal'),
    countryCode: CountryCodes.PT,
    dialCode: '+351',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.PRT
  },
  {
    name: t('countries.pr.label|PR country name label', 'Puerto Rico'),
    countryCode: CountryCodes.PR,
    dialCode: '+1',
    priority: 3,
    areaCodes: ["787", "939"],
    ISO3CountryCodes: ISO3CountryCodes.PRI
  },
  {
    name: t('countries.qa.label|QA country name label', 'Qatar (‫قطر‬‎)'),
    countryCode: CountryCodes.QA,
    dialCode: '+974',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.QAT
  },
  {
    name: t('countries.re.label|RE country name label', 'Réunion (La Réunion)'),
    countryCode: CountryCodes.RE,
    dialCode: '+262',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.REU
  },
  {
    name: t('countries.ro.label|RO country name label', 'Romania (România)'),
    countryCode: CountryCodes.RO,
    dialCode: '+40',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ROU
  },
  {
    name: t('countries.ru.label|RU country name label', 'Russia (Россия)'),
    countryCode: CountryCodes.RU,
    dialCode: '+7',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.RUS
  },
  {
    name: t('countries.rw.label|RW country name label', 'Rwanda'),
    countryCode: CountryCodes.RW,
    dialCode: '+250',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.RWA
  },
  {
    name: t('countries.bl.label|BL country name label', 'Saint Barthélemy'),
    countryCode: CountryCodes.BL,
    dialCode: '+590',
    priority: 1,
    ISO3CountryCodes: ISO3CountryCodes.BLM
  },
  {
    name: t('countries.sh.label|SH country name label', 'Saint Helena'),
    countryCode: CountryCodes.SH,
    dialCode: '+290',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SHN
  },
  {
    name: t('countries.kn.label|KN country name label', 'Saint Kitts and Nevis'),
    countryCode: CountryCodes.KN,
    dialCode: '+1',
    priority: 18,
    areaCodes: ["869"],
    ISO3CountryCodes: ISO3CountryCodes.KNA
  },
  {
    name: t('countries.lc.label|LC country name label', 'Saint Lucia'),
    countryCode: CountryCodes.LC,
    dialCode: '+1',
    priority: 19,
    areaCodes: ["758"],
    ISO3CountryCodes: ISO3CountryCodes.LCA
  },
  {
    name: t('countries.mf.label|MF country name label', 'Saint Martin (Saint-Martin (partie française))'),
    countryCode: CountryCodes.MF,
    dialCode: '+590',
    priority: 2,
    ISO3CountryCodes: ISO3CountryCodes.MAF
  },
  {
    name: t('countries.pm.label|PM country name label', 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)'),
    countryCode: CountryCodes.PM,
    dialCode: '+508',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SPM
  },
  {
    name: t('countries.vc.label|VC country name label', 'Saint Vincent and the Grenadines'),
    countryCode: CountryCodes.VC,
    dialCode: '+1',
    priority: 20,
    areaCodes: ["784"],
    ISO3CountryCodes: ISO3CountryCodes.VCT
  },
  {
    name: t('countries.ws.label|WS country name label', 'Samoa'),
    countryCode: CountryCodes.WS,
    dialCode: '+685',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.WSM
  },
  {
    name: t('countries.sm.label|SM country name label', 'San Marino'),
    countryCode: CountryCodes.SM,
    dialCode: '+378',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SMR
  },
  {
    name: t('countries.st.label|ST country name label', 'São Tomé and Príncipe (São Tomé e Príncipe)'),
    countryCode: CountryCodes.ST,
    dialCode: '+239',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.STP
  },
  {
    name: t('countries.sa.label|SA country name label', 'Saudi Arabia (‫المملكة العربية السعودية‬‎)'),
    countryCode: CountryCodes.SA,
    dialCode: '+966',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SAU
  },
  {
    name: t('countries.sn.label|SN country name label', 'Senegal (Sénégal)'),
    countryCode: CountryCodes.SN,
    dialCode: '+221',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SEN
  },
  {
    name: t('countries.rs.label|RS country name label', 'Serbia (Србија)'),
    countryCode: CountryCodes.RS,
    dialCode: '+381',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SRB
  },
  {
    name: t('countries.sc.label|SC country name label', 'Seychelles'),
    countryCode: CountryCodes.SC,
    dialCode: '+248',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SYC
  },
  {
    name: t('countries.sl.label|SL country name label', 'Sierra Leone'),
    countryCode: CountryCodes.SL,
    dialCode: '+232',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SLE
  },
  {
    name: t('countries.sg.label|SG country name label', 'Singapore'),
    countryCode: CountryCodes.SG,
    dialCode: '+65',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SGP
  },
  {
    name: t('countries.sx.label|SX country name label', 'Sint Maarten'),
    countryCode: CountryCodes.SX,
    dialCode: '+1',
    priority: 21,
    areaCodes: ["721"],
    ISO3CountryCodes: ISO3CountryCodes.SXM
  },
  {
    name: t('countries.sk.label|SK country name label', 'Slovakia (Slovensko)'),
    countryCode: CountryCodes.SK,
    dialCode: '+421',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SVK
  },
  {
    name: t('countries.si.label|SI country name label', 'Slovenia (Slovenija)'),
    countryCode: CountryCodes.SI,
    dialCode: '+386',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SVN
  },
  {
    name: t('countries.sb.label|SB country name label', 'Solomon Islands'),
    countryCode: CountryCodes.SB,
    dialCode: '+677',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SLB
  },
  {
    name: t('countries.so.label|SO country name label', 'Somalia (Soomaaliya)'),
    countryCode: CountryCodes.SO,
    dialCode: '+252',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SOM
  },
  {
    name: t('countries.za.label|ZA country name label', 'South Africa'),
    countryCode: CountryCodes.ZA,
    dialCode: '+27',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ZAF
  },
  {
    name: t('countries.kr.label|KR country name label', 'South Korea (대한민국)'),
    countryCode: CountryCodes.KR,
    dialCode: '+82',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.KOR
  },
  {
    name: t('countries.ss.label|SS country name label', 'South Sudan (‫جنوب السودان‬‎)'),
    countryCode: CountryCodes.SS,
    dialCode: '+211',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SSD
  },
  {
    name: t('countries.es.label|ES country name label', 'Spain (España)'),
    countryCode: CountryCodes.ES,
    dialCode: '+34',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ESP
  },
  {
    name: t('countries.lk.label|LK country name label', 'Sri Lanka (ශ්‍රී ලංකාව)'),
    countryCode: CountryCodes.LK,
    dialCode: '+94',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.LKA
  },
  {
    name: t('countries.sd.label|SD country name label', 'Sudan (‫السودان‬‎)'),
    countryCode: CountryCodes.SD,
    dialCode: '+249',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SDN
  },
  {
    name: t('countries.sr.label|SR country name label', 'Suriname'),
    countryCode: CountryCodes.SR,
    dialCode: '+597',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SUR
  },
  {
    name: t('countries.sj.label|SJ country name label', 'Svalbard and Jan Mayen'),
    countryCode: CountryCodes.SJ,
    dialCode: '+47',
    priority: 1,
    areaCodes: ["79"],
    ISO3CountryCodes: ISO3CountryCodes.SJM
  },
  {
    name: t('countries.se.label|SE country name label', 'Sweden (Sverige)'),
    countryCode: CountryCodes.SE,
    dialCode: '+46',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SWE
  },
  {
    name: t('countries.ch.label|CH country name label', 'Switzerland (Schweiz)'),
    countryCode: CountryCodes.CH,
    dialCode: '+41',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.CHE
  },
  {
    name: t('countries.sy.label|SY country name label', 'Syria (‫سوريا‬‎)'),
    countryCode: CountryCodes.SY,
    dialCode: '+963',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.SYR
  },
  {
    name: t('countries.tw.label|TW country name label', 'Taiwan (台灣)'),
    countryCode: CountryCodes.TW,
    dialCode: '+886',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TWN
  },
  {
    name: t('countries.tj.label|TJ country name label', 'Tajikistan'),
    countryCode: CountryCodes.TJ,
    dialCode: '+992',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TJK
  },
  {
    name: t('countries.tz.label|TZ country name label', 'Tanzania'),
    countryCode: CountryCodes.TZ,
    dialCode: '+255',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TZA
  },
  {
    name: t('countries.th.label|TH country name label', 'Thailand (ไทย)'),
    countryCode: CountryCodes.TH,
    dialCode: '+66',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.THA
  },
  {
    name: t('countries.tl.label|TL country name label', 'Timor-Leste'),
    countryCode: CountryCodes.TL,
    dialCode: '+670',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TLS
  },
  {
    name: t('countries.tg.label|TG country name label', 'Togo'),
    countryCode: CountryCodes.TG,
    dialCode: '+228',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TGO
  },
  {
    name: t('countries.tk.label|TK country name label', 'Tokelau'),
    countryCode: CountryCodes.TK,
    dialCode: '+690',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TKL
  },
  {
    name: t('countries.to.label|TO country name label', 'Tonga'),
    countryCode: CountryCodes.TO,
    dialCode: '+676',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TON
  },
  {
    name: t('countries.tt.label|TT country name label', 'Trinidad and Tobago'),
    countryCode: CountryCodes.TT,
    dialCode: '+1',
    priority: 22,
    areaCodes: ["868"],
    ISO3CountryCodes: ISO3CountryCodes.TTO
  },
  {
    name: t('countries.tn.label|TN country name label', 'Tunisia (‫تونس‬‎)'),
    countryCode: CountryCodes.TN,
    dialCode: '+216',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TUN
  },
  {
    name: t('countries.tr.label|TR country name label', 'Turkey (Türkiye)'),
    countryCode: CountryCodes.TR,
    dialCode: '+90',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TUR
  },
  {
    name: t('countries.tm.label|TM country name label', 'Turkmenistan'),
    countryCode: CountryCodes.TM,
    dialCode: '+993',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TKM
  },
  {
    name: t('countries.tc.label|TC country name label', 'Turks and Caicos Islands'),
    countryCode: CountryCodes.TC,
    dialCode: '+1',
    priority: 23,
    areaCodes: ["649"],
    ISO3CountryCodes: ISO3CountryCodes.TCA
  },
  {
    name: t('countries.tv.label|TV country name label', 'Tuvalu'),
    countryCode: CountryCodes.TV,
    dialCode: '+688',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.TUV
  },
  {
    name: t('countries.vi.label|VI country name label', 'U.S. Virgin Islands'),
    countryCode: CountryCodes.VI,
    dialCode: '+1',
    priority: 24,
    areaCodes: ["340"],
    ISO3CountryCodes: ISO3CountryCodes.VIR
  },
  {
    name: t('countries.ug.label|UG country name label', 'Uganda'),
    countryCode: CountryCodes.UG,
    dialCode: '+256',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.UGA
  },
  {
    name: t('countries.ua.label|UA country name label', 'Ukraine (Україна)'),
    countryCode: CountryCodes.UA,
    dialCode: '+380',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.UKR
  },
  {
    name: t('countries.ae.label|AE country name label', 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)'),
    countryCode: CountryCodes.AE,
    dialCode: '+971',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ARE
  },
  {
    name: t('countries.gb.label|GB country name label', 'United Kingdom'),
    countryCode: CountryCodes.GB,
    dialCode: '+44',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.GBR
  },
  {
    name: t('countries.us.label|US country name label', 'United States'),
    countryCode: CountryCodes.US,
    dialCode: '+1',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.USA
  },
  {
    name: t('countries.uy.label|UY country name label', 'Uruguay'),
    countryCode: CountryCodes.UY,
    dialCode: '+598',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.URY
  },
  {
    name: t('countries.uz.label|UZ country name label', 'Uzbekistan (Oʻzbekiston)'),
    countryCode: CountryCodes.UZ,
    dialCode: '+998',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.UZB
  },
  {
    name: t('countries.vu.label|VU country name label', 'Vanuatu'),
    countryCode: CountryCodes.VU,
    dialCode: '+678',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.VUT
  },
  {
    name: t('countries.va.label|VA country name label', 'Vatican City (Città del Vaticano)'),
    countryCode: CountryCodes.VA,
    dialCode: '+39',
    priority: 1,
    areaCodes: ["06698"],
    ISO3CountryCodes: ISO3CountryCodes.VAT
  },
  {
    name: t('countries.ve.label|VE country name label', 'Venezuela'),
    countryCode: CountryCodes.VE,
    dialCode: '+58',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.VEN
  },
  {
    name: t('countries.vn.label|VN country name label', 'Vietnam (Việt Nam)'),
    countryCode: CountryCodes.VN,
    dialCode: '+84',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.VNM
  },
  {
    name: t('countries.wf.label|WF country name label', 'Wallis and Futuna (Wallis-et-Futuna)'),
    countryCode: CountryCodes.WF,
    dialCode: '+681',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.WLF
  },
  {
    name: t('countries.eh.label|EH country name label', 'Western Sahara (‫الصحراء الغربية‬‎)'),
    countryCode: CountryCodes.EH,
    dialCode: '+212',
    priority: 1,
    areaCodes: ["5288", "5289"],
    ISO3CountryCodes: ISO3CountryCodes.ESH
  },
  {
    name: t('countries.ye.label|YE country name label', 'Yemen (‫اليمن‬‎)'),
    countryCode: CountryCodes.YE,
    dialCode: '+967',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.YEM
  },
  {
    name: t('countries.zm.label|ZM country name label', 'Zambia'),
    countryCode: CountryCodes.ZM,
    dialCode: '+260',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ZMB
  },
  {
    name: t('countries.zw.label|ZW country name label', 'Zimbabwe'),
    countryCode: CountryCodes.ZW,
    dialCode: '+263',
    priority: 0,
    ISO3CountryCodes: ISO3CountryCodes.ZWE
  },
  {
    name: t('countries.ax.label|AX country name label', 'Åland Islands'),
    countryCode: CountryCodes.AX,
    dialCode: '+358',
    priority: 1,
    areaCodes: ["18"],
    ISO3CountryCodes: ISO3CountryCodes.ALA
  }
];
